import React from "react";
import { Box } from "@mui/material";

import FilterAutocomplete from "../../../../components/ui/FilterAutocomplete";
import { useEvaluationsContext } from "../../../../context";
import { REGULAR_EVALUATIONS_FILTERS, INPUT_TYPES } from "../../constants";

const Filters = (): React.ReactElement => {
  const { search, setSearch } = useEvaluationsContext();

  return (
    <Box mb="10px">
      <FilterAutocomplete
        // @ts-ignore
        search={search}
        setSearch={setSearch}
        filters={{
          ...REGULAR_EVALUATIONS_FILTERS,
        }}
        inputTypes={INPUT_TYPES}
      />
    </Box>
  );
};

export default Filters;
